const mEditionBillingArtificialIntelligenceUsageRecord = {
  mEditionBillingArtificialIntelligenceUsageRecord: {
    alerts: {
      readGeneraciones: {
        error: 'Un error ha ocurrido al cargar el detalle de las generaciones. Vuelve a intentarlo en un momento.'
      },

      readLicencia: {
        error: 'Un error ha ocurrido al cargar la ficha. Revisá que la licencia exista y volvé a intentarlo.'
      }
    },

    apps: {
      academy: 'Academy',
      classroom: 'Aula',
      evaluaciones: 'Evaluaciones',
      juedroop: 'Juedroop'
    },

    charts: {
      byAppSubtitle: 'Créditos consumidos por la licencia en cada app.',
      byAppTitle: 'Desde dónde usa la IA',
      byCycleSubtitle: 'Créditos consumidos en cada ciclo ya cerrado. La línea de referencia es el cupo del plan.',
      byCycleTitle: 'Cómo viene ciclo a ciclo',
      byTypeSubtitle: 'Reparto del costo del proveedor entre lo que generó.',
      byTypeTitle: 'En qué se le va la plata',
      empty: 'Todavía no hay nada registrado.'
    },

    context: {
      generated: 'Lo que generó la IA',
      hide: 'Ocultar el contexto',
      note: 'Es material del cliente: puede traer datos de sus alumnos o contenido con derechos. Mirálo solo si hace falta y no lo copies fuera de acá.',
      show: 'Ver el contexto que escribió el cliente',
      written: 'Lo que escribió el cliente'
    },

    detail: {
      empty: 'No hay ninguna generación registrada con estos filtros.',
      subtitle: 'Una fila por llamada a la IA, de la más nueva a la más vieja.',
      title: 'Generación por generación'
    },

    filters: {
      appAll: 'App: todas',
      from: 'desde',
      resultAll: 'Resultado: todos',
      resultFailed: 'Solo las fallidas',
      resultOk: 'Solo las exitosas',
      to: 'hasta',
      typeAll: 'Tipo: todos'
    },

    history: {
      empty: 'Todavía no se cerró ningún ciclo de esta licencia.',
      subtitle: 'Una fila por ciclo cerrado, del más nuevo al más viejo.',
      title: 'Historial de ciclos'
    },

    historyTable: {
      thAccumulated: 'Acumulado',
      thCredits: 'Créditos del ciclo',
      thCurrent: 'Vigente',
      thPeriod: 'Ciclo',
      thTotal: 'Total del ciclo'
    },

    income: {
      cost: 'Costo del proveedor',
      empty: 'Esta licencia no tiene pagos acreditados.',
      lastPayment: 'Último pago',
      paid: 'Lo que pagó el cliente',
      payments: 'pagos acreditados',
      subtitle: 'Las dos cifras de esta licencia, cada una en su moneda.',
      title: 'Lo que paga contra lo que cuesta'
    },

    labels: {
      account: 'Cuenta satélite',
      available: 'Disponible',
      credits: 'Créditos del plan',
      cycleAccumulated: 'Consumo acumulado',
      cycleCurrent: 'Consumo del ciclo',
      cycleDay: 'Se le renueva el día',
      email: 'Email',
      of: 'de',
      period: 'Ciclo en curso desde el',
      purchase: 'Comprada el',
      useCredits: 'Usa los paquetes al agotar el mes'
    },

    links: {
      sale: 'Ver la venta que la originó',
      title: 'Para seguir tirando del hilo',
      user: 'Ver todo lo que compró este cliente'
    },

    messages: {
      noName: 'Sin razón social',
      notFound: 'No se encontró esta licencia de IA.'
    },

    modalities: {
      creditos: 'Paquete de créditos',
      mensual: 'Plan mensual'
    },

    states: {
      activa: 'Activa',
      agotada: 'Agotada',
      eliminada: 'Eliminada',
      suspendida: 'Suspendida'
    },

    table: {
      thAmount: 'Cantidad',
      thCostUsd: 'Costo USD',
      thCredits: 'Créditos',
      thDate: 'Fecha',
      thDuration: 'Duración',
      thModel: 'Modelo',
      thResult: 'Resultado',
      thTokens: 'Tokens',
      thType: 'Tipo'
    },

    totals: {
      amount: 'Preguntas e imágenes',
      costUsd: 'Costo del proveedor',
      credits: 'Créditos consumidos',
      creditsCharged: 'Créditos cobrados',
      failed: 'fallidas',
      generations: 'Generaciones',
      successful: 'exitosas',
      title: 'Todo lo que generó esta licencia'
    },

    typeTable: {
      thAmount: 'Cantidad',
      thCostUsd: 'Costo USD',
      thCredits: 'Créditos',
      thGenerations: 'Generaciones',
      thType: 'Tipo'
    },

    types: {
      imagen_pregunta: 'Imágenes de pregunta',
      portada: 'Portadas',
      preguntas: 'Preguntas'
    },

    values: {
      asked: 'pedidas',
      failed: 'Falló',
      in: 'entrada',
      no: 'No',
      none: 'Sin dato',
      ok: 'Exitosa',
      out: 'salida',
      planCredits: 'Cupo del plan',
      stage: 'Etapa',
      yes: 'Sí'
    },

    warnings: {
      noCharge: 'El cobro está apagado: no se descuenta nada.',
      noRegistry: 'El registro está apagado: esto no se está guardando.',
      orientative: 'El costo y las generaciones de esta ficha son orientativos: un consumo repartido entre varias licencias se anota en una sola. Para cuadrar créditos mandan el consumo del ciclo y el acumulado.',
      title: 'Ojo con lo que estás mirando'
    }
  }
}

export default mEditionBillingArtificialIntelligenceUsageRecord
